import {
  AnalyticsEventBuilder,
  AnalyticsEventAction,
  AnalyticsEvent,
} from "./../AnalyticsEventBuilder";
import { Game } from "../../../models/Game";

export class HomeAnalyticsAi {
  promoImpression(promoKey: string): AnalyticsEvent {
    const event = this.newEventBuilder();
    event.setName("bigPromo");
    event.setEventAction(AnalyticsEventAction.IMPRESSION);
    event.setNonInteraction(true);
    event.setCustom("gameCarousel", promoKey);
    event.setCustom("theatreModeOn", false);
    return event.build();
  }

  promoClick(key: string, index: number): AnalyticsEvent {
    const event = this.newEventBuilder();
    event.setName("bigPromo");
    event.setEventAction(AnalyticsEventAction.CLICK);
    event.setNonInteraction(false);
    event.setCustom("game", key);
    event.setCustom("theatreModeOn", false);
    return event.build();
  }

  private newEventBuilder(): AnalyticsEventBuilder {
    return new AnalyticsEventBuilder().baseEvent();
  }
}
